  import React, { useEffect, useContext, useReducer } from 'react';
  import reducer from '../reducers/order_reducer';
  import {
    UPDATE_SHIPPING_DETAILS,
    GET_ORDERS_BEGIN,
    GET_ORDERS_SUCCESS,
    GET_ORDERS_ERROR,
  } from '../actions';
  import { useUserContext } from './user_context';
  import { useCartContext } from './cart_context';
  import { toast } from 'react-toastify';
  import axios from 'axios';
  import { get_order_url, create_order_url } from '../utils/constants';

  const initialState = {
    orders_loading: false,
    orders_error: false,
    orders: [],
    shipping: {
      name: '',
      address: {
        line1: '',
        postal_code: '',
        city: '',
        state: '',
        country: '',
      },
    },
  };

  const OrderContext = React.createContext();

  export const OrderProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const { currentUser } = useUserContext();
    const { cart, total_amount, shipping_fee } = useCartContext();

    const fetchOrders = async () => {
      if (!currentUser || !currentUser.email) {
        console.log('fetchOrders: No currentUser or email', currentUser);
        return;
      }
      console.log('fetchOrders: Fetching orders for email:', currentUser.email);
      dispatch({ type: GET_ORDERS_BEGIN });
      try {
        const response = await axios.post(get_order_url, {
          email: currentUser.email,
        });
        console.log('fetchOrders: Response received:', response.data);
        const orders = response.data.data || [];
        console.log('fetchOrders: Orders to dispatch:', orders);
        dispatch({ type: GET_ORDERS_SUCCESS, payload: orders });
      } catch (error) {
        console.error('fetchOrders: Error:', error);
        dispatch({ type: GET_ORDERS_ERROR });
      }
    };

    const placeOrder = async () => {
      const shippingInfo = {
        address: state.shipping.address.line1,
        city: state.shipping.address.city,
        state: state.shipping.address.state,
        country: state.shipping.address.country,
        pinCode: state.shipping.address.postal_code,
        phoneNumber: state.shipping.phone_number,
      };
      const orderItems = cart.map((item) => {
        return {
          name: item.name,
          price: item.price,
          quantity: item.amount,
          image: item.image,
          color: item.color,
          colorName: item.colorName,
          size: item.size,
          product: item.id.replace(item.color + item.size, ''),
        };
      });
      // UPDATED: Changed from online payment to Cash on Delivery
      const paymentInfo = {
        id: 'COD_' + Date.now(),
        status: 'Cash on Delivery',
      };
      const body = {
        name: state.shipping.name,
        email: currentUser ? currentUser.email : 'guest@cashondelivery.com',
        shippingInfo,
        orderItems,
        paymentInfo,
        itemsPrice: total_amount,
        shippingPrice: shipping_fee,
        totalPrice: total_amount + shipping_fee,
      };
      try {
        console.log('placeOrder: Creating order with body:', body);
        const createResponse = await axios.post(create_order_url, body);
        console.log('placeOrder: Order created:', createResponse.data);
        toast.success('Order placed successfully! You will pay on delivery.');
        // Refetch orders after successfully placing an order
        if (currentUser && currentUser.email) {
          console.log('placeOrder: Refetching orders for:', currentUser.email);
          const response = await axios.post(get_order_url, {
            email: currentUser.email,
          });
          console.log('placeOrder: Orders fetched after creation:', response.data);
          const orders = response.data.data || [];
          dispatch({ type: GET_ORDERS_SUCCESS, payload: orders });
        }
      } catch (error) {
        console.error('placeOrder: Error:', error);
        toast.error(error.message);
      }
    };

    const updateShipping = (e) => {
      const name = e.target.name;
      const value = e.target.value;
      dispatch({ type: UPDATE_SHIPPING_DETAILS, payload: { name, value } });
    };

    useEffect(() => {
      if (currentUser && currentUser.email) {
        fetchOrders();
      }
      // eslint-disable-next-line
    }, [currentUser]);

    return (
      <OrderContext.Provider value={{ ...state, updateShipping, placeOrder, fetchOrders }}>
        {children}
      </OrderContext.Provider>
    );
  };
  // make sure use
  export const useOrderContext = () => {
    return useContext(OrderContext);
  };
